import { FooterWrapper } from '@apps/layouts/Footer/styles';
import styled, { createGlobalStyle } from 'styled-components';

export const ConsignWrapper = styled.section`
  width: 100%;
`;

/**
 * This section ends in a light grey band, against which the footer's 2px near-black rule
 * reads as far too heavy. Scoped to the container so the border returns wherever it is absent.
 */
export const FooterBorderReset = createGlobalStyle`
  ${FooterWrapper} {
    border-top: none;
  }
`;

/**
 * Re-centers content back onto the site's 1240px column.
 * Vertical padding is left to each section, so the banner can sit flush against its image.
 */
export const ConsignInner = styled.div`
  max-width: 1240px;
  margin: 0 auto;
  padding: 0 20px;
`;
